function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import Button from '@mapbox/mr-ui/button';
import Icon from '@mapbox/mr-ui/icon';
import PopoverTrigger from '@mapbox/mr-ui/popover-trigger';
export default class BackToTopButton extends React.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getPopoverContent", () => {
      return /*#__PURE__*/React.createElement("div", {
        className: "txt-s"
      }, "Back to top!");
    });
  }

  render() {
    function handleClick() {
      document.documentElement.scrollTop = 0; // fallback

      window.scroll(0, 0);
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "mx24 my24 z5"
    }, /*#__PURE__*/React.createElement(PopoverTrigger, {
      respondsToClick: false,
      respondsToHover: true,
      content: this.getPopoverContent,
      popoverProps: {
        alignment: 'center',
        placement: 'top',
        padding: 'small'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: handleClick,
      passthroughProps: {
        className: 'btn btn--blue w60 h60 round-full shadow-darken25 flex flex--center-main flex--center-cross',
        'aria-label': 'Back to top'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "arrow-up",
      size: 30
    }))));
  }

}